export default __webpack_public_path__ + "static/media/visa.afe70d89.svg";